export const proofofnarnianNFTs = [
  
  {
    "id": "narnian-3333",
    "name": "Proof of Narnian #3333",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3333?s=b34a79d54c309a6f54b5380ee2400c8a",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3332", 
    "name": "Proof of Narnian #3332",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3332?s=78aab1c71574912c8bdefa104727efe8",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3331",
    "name": "Proof of Narnian #3331", 
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3331?s=77b2bc77365781510b18fe61b7bc0bee",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3330",
    "name": "Proof of Narnian #3330",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3330?s=d5f8aa8bd7dd1b7066a1bfcccd0e4ef8",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3329",
    "name": "Proof of Narnian #3329",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3329?s=caa1b43e84fd52943befc25e29e33c8a",
    "price": "2.2 ETH"
  },
  {
    "id": "narnian-3328",
    "name": "Proof of Narnian #3328",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3328?s=b5bc01f3ff981bd52b04677a798225f8",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3327",
    "name": "Proof of Narnian #3327",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3327?s=cfa2105d3c25ecfec6c31df70141c414",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3326",
    "name": "Proof of Narnian #3326",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3326?s=0c010670d77f356f9c6ca1e9897d6669",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3325",
    "name": "Proof of Narnian #3325",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3325?s=0bc2abe12cb2087c1909f050ed8bd962",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3324",
    "name": "Proof of Narnian #3324",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3324?s=b3ef907b1fbbeea749557d8af8f58778",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3323",
    "name": "Proof of Narnian #3323",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3323?s=0396fe4c6e13711f80165b4e48e82294",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3322",
    "name": "Proof of Narnian #3322",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3322?s=c551f34f5f7a24b997b0a1bdfc78bf44",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3321",
    "name": "Proof of Narnian #3321",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3321?s=4a68dc69c17aaca03cf38f11e24b6469",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3320",
    "name": "Proof of Narnian #3320",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3320?s=d00c4824142f246f13dad5d6e956ae1c",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3319",
    "name": "Proof of Narnian #3319",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3319?s=1d806c3bff3b028dbaacecda854dc31c",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3318",
    "name": "Proof of Narnian #3318",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3318?s=499b850179c3eea61abeb827731b5aff",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3317",
    "name": "Proof of Narnian #3317",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3317?s=d28497dbd8516ad06f40189ecce9585f",
    "price": "2.2 ETH"
  },
  {
    "id": "narnian-3316",
    "name": "Proof of Narnian #3316",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3316?s=df3def21cfe104d5f904fe2e4a27fd04",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3315",
    "name": "Proof of Narnian #3315",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3315?s=e68399b71629f6c1a83a775a44ccb054",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3314",
    "name": "Proof of Narnian #3314",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3314?s=d98feb992692762c9b0326b7ed85a571",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3313",
    "name": "Proof of Narnian #3313",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3313?s=e2ded95ded5615cc629c85fe761b96db",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3312",
    "name": "Proof of Narnian #3312",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3312?s=bc68a69223abeb185b15fe11c512add1",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3311",
    "name": "Proof of Narnian #3311",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3311?s=6022ea336492d676b0e4baa2a5c752b2",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3310",
    "name": "Proof of Narnian #3310",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3310?s=99fcbc76c036456b5010b8e8e69025f3",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3309",
    "name": "Proof of Narnian #3309",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3309?s=d936276e7a53080f78468237a6cc767b",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3308",
    "name": "Proof of Narnian #3308",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3308?s=19f2cc8000a99c1b8698157b6451abf6",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3307",
    "name": "Proof of Narnian #3307",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3307?s=2858d3e413ccd59fbcdd4db911e19472",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3306",
    "name": "Proof of Narnian #3306",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3306?s=507e817dbc0b66d6a12c62176f250255",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3305",
    "name": "Proof of Narnian #3305",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3305?s=1c6f0c8390d18e5faf955431e74f5b5f",
    "price": "2.2 ETH"
  },
  {
    "id": "narnian-3304",
    "name": "Proof of Narnian #3304",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3304?s=f3100c916568ab2eb67de31ed67b7a4f",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3303",
    "name": "Proof of Narnian #3303",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3303?s=9101efa1b7c784c01673eb472d0778e0",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3302",
    "name": "Proof of Narnian #3302",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3302?s=e0b8bbbacf9955dcd3fcd674fb51f65d",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3301",
    "name": "Proof of Narnian #3301",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3301?s=31938f7de6b88ad093008abd38fec6b6",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3300",
    "name": "Proof of Narnian #3300",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3300?s=e989220618b691180795749b25f836f0",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3299",
    "name": "Proof of Narnian #3299",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3299?s=6e47bb30da7217145e67da45264e1913",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3298",
    "name": "Proof of Narnian #3298",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3298?s=494bff8c35046ba514d15bddbb4d9323",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3297",
    "name": "Proof of Narnian #3297",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3297?s=0b1427fd8dd62e1b4f1ad3a5a3129871",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3296",
    "name": "Proof of Narnian #3296",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3296?s=7e22cfcf7a673845e131357a1fab2fe6",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3295",
    "name": "Proof of Narnian #3295",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3295?s=379e3721ad5a54fea0050af3cd8962ea",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3294",
    "name": "Proof of Narnian #3294",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3294?s=8fbed4c21384030276714ea96af3a0d0",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3293",
    "name": "Proof of Narnian #3293",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3293?s=be537d29bddfbad870646db35fef16ea",
    "price": "2.2 ETH"
  },
  {
    "id": "narnian-3292",
    "name": "Proof of Narnian #3292",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3292?s=72494ca0a4875d25117ace8fa572fe08",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3291",
    "name": "Proof of Narnian #3291",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3291?s=d39b1c88cafe37f9507c2bf1bc7a1419",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3290",
    "name": "Proof of Narnian #3290",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3290?s=2f270e592bddaa8c1bee4078ada5df11",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3289",
    "name": "Proof of Narnian #3289",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3289?s=694109aac4a5c2bfb099d306918910c5",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3288",
    "name": "Proof of Narnian #3288",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3288?s=ac73f59a860731c33780114cd0f142a2",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3287",
    "name": "Proof of Narnian #3287",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3287?s=be93d0aa0b73376ac894e94c51b6a268",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3286",
    "name": "Proof of Narnian #3286",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3286?s=8db46a6e065584fb4030148d20611c6c",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3285",
    "name": "Proof of Narnian #3285",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3285?s=a9c9a019c07552576cde0d4709a6143f",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3284",
    "name": "Proof of Narnian #3284",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3284?s=8fe4534a14ee50cd07022183919a5899",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3283",
    "name": "Proof of Narnian #3283",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3283?s=265058f2965aebeeb4e3e6160dd4263d",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3282",
    "name": "Proof of Narnian #3282",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3282?s=12e14ecb47c35559dd1ba698fb22c614",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3281",
    "name": "Proof of Narnian #3281",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3281?s=6d5749f74bf1b4dd6c3e2cf21dd2b7d2",
    "price": "2.2 ETH"
  },
    

  {
    "id": "narnian-3280",
    "name": "Proof of Narnian #3280",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3280?s=097bd90df69c35411683c0bf26b87616",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3279",
    "name": "Proof of Narnian #3279",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3279?s=98d7a74e3c32d308b4d12e9f29677276",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3278",
    "name": "Proof of Narnian #3278",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3278?s=fc03f8749114d3594cec722f98bdb756",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3277",
    "name": "Proof of Narnian #3277",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3277?s=97375cf6e8952e11e1a9620817c51d37",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3276",
    "name": "Proof of Narnian #3276",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3276?s=fd648066573a33aac2105f1312883bb0",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3275",
    "name": "Proof of Narnian #3275",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3275?s=10bcfb447a4532ecbe0508d880ccceb3",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3274",
    "name": "Proof of Narnian #3274",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3274?s=613e4e51521a5b162cc878e72f3c6417",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3273",
    "name": "Proof of Narnian #3273",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3273?s=2149f3961622c93da1cd77901a1e3156",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3272",
    "name": "Proof of Narnian #3272",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3272?s=b22424e76205f7903b221f918ae0d291",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3271",
    "name": "Proof of Narnian #3271",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3271?s=e058d3e1b8c7f1914d734e176b40e8d0",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3270",
    "name": "Proof of Narnian #3270",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3270?s=da41c2b0a2ab88e61f9b51512eefa62c",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3269",
    "name": "Proof of Narnian #3269",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3269?s=622c0bcc64cfe82249ab587284a0971b",
    "price": "2.2 ETH"
  },
  {
    "id": "narnian-3268",
    "name": "Proof of Narnian #3268",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3268?s=754446622986b3d6a1f3fc93e59d1415",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3267",
    "name": "Proof of Narnian #3267",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3267?s=fd69bf8ca34ae2c7e4556b6a64426d21",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3266",
    "name": "Proof of Narnian #3266",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3266?s=20963667d848e57e840d11666e5fe51a",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3265",
    "name": "Proof of Narnian #3265",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3265?s=7ef33fb387ff65bf747374959af19ec6",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3264",
    "name": "Proof of Narnian #3264",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3264?s=2a517538714f4b326213b43779f28db1",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3263",
    "name": "Proof of Narnian #3263",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3263?s=fee4b6f407b7cfe10e0b7ceb369127ce",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3262",
    "name": "Proof of Narnian #3262",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3262?s=f224fcc112b95c151eac4f05985305dd",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3261",
    "name": "Proof of Narnian #3261",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3261?s=54c1e18083fc8507df1c1d4a6f3de86b",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3260",
    "name": "Proof of Narnian #3260",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3260?s=e125462464e2fdf4c3cffdb2384544df",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3259",
    "name": "Proof of Narnian #3259",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3259?s=a82c408f9a613ed187e9b34c256eb794",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3258",
    "name": "Proof of Narnian #3258",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3258?s=6cc891d7bc62a803b62ce44be9cadd98",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3257",
    "name": "Proof of Narnian #3257",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3257?s=4ad13a074e70c540d06c2351fe6b85e4",
    "price": "2.2 ETH"
  },
  {
    "id": "narnian-3256",
    "name": "Proof of Narnian #3256",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3256?s=4c9dad0381de3be0474176218d132bfb",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3255",
    "name": "Proof of Narnian #3255",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3255?s=fddc5c40b1b82dacee7f41ef0fa44589",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3254",
    "name": "Proof of Narnian #3254",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3254?s=bb002c006dbee56930fa69743e5d95aa",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3253",
    "name": "Proof of Narnian #3253",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3253?s=e9c1d84610e4a62896089a8ac9e6c2b8",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3252",
    "name": "Proof of Narnian #3252",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3252?s=37a9e5c801f26a17696aa0e053e811f2",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3251",
    "name": "Proof of Narnian #3251",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3251?s=f887f69ff63a9343662b3f9136c19239",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3250",
    "name": "Proof of Narnian #3250",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3250?s=4e1adf947f89a3848f2d45e18ce42d1a",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3249",
    "name": "Proof of Narnian #3249",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3249?s=158f8476c5309bdde76884f037f03f64",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3248",
    "name": "Proof of Narnian #3248",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3248?s=2e1291bb01ff5bdf3be27dc17225593e",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3247",
    "name": "Proof of Narnian #3247",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3247?s=162de94c15dcef60470dbfacb3d20fc6",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3246",
    "name": "Proof of Narnian #3246",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3246?s=4a7f56d0b71ae6f1bba6512978946e78",
    "price": "1.9 ETH"
  },
  {
    "id": "narnian-3245",
    "name": "Proof of Narnian #3245",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3245?s=fc154950a602492b1973f517a061a837",
    "price": "2.2 ETH"
  },
  {
    "id": "narnian-3244",
    "name": "Proof of Narnian #3244",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3244?s=da6f766fad7c4583b1981c9da27d4fe7",
    "price": "1.5 ETH"
  },
  {
    "id": "narnian-3243",
    "name": "Proof of Narnian #3243",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3243?s=6c5c85b33ec22383545717b02b9daea3",
    "price": "1.7 ETH"
  },
  {
    "id": "narnian-3242",
    "name": "Proof of Narnian #3242",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3242?s=e6d7309734386f9fc3f8dce6d56a64a7",
    "price": "2.0 ETH"
  },
  {
    "id": "narnian-3241",
    "name": "Proof of Narnian #3241",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3241?s=c1e482b84e342f2da6f798bd1e267499",
    "price": "1.2 ETH"
  },
  {
    "id": "narnian-3240",
    "name": "Proof of Narnian #3240",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3240?s=6d66aa81f5a39b5a3a05b2906cb6f481",
    "price": "1.6 ETH"
  },
  {
    "id": "narnian-3239",
    "name": "Proof of Narnian #3239",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3239?s=226ddfa78f0edf1e02c9571f0113edb0",
    "price": "2.3 ETH"
  },
  {
    "id": "narnian-3238",
    "name": "Proof of Narnian #3238",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3238?s=00078ec63f6dd33706513280ef478ff7",
    "price": "1.4 ETH"
  },
  {
    "id": "narnian-3237",
    "name": "Proof of Narnian #3237",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3237?s=74012eff1a61072ba245f5e10592432b",
    "price": "1.8 ETH"
  },
  {
    "id": "narnian-3236",
    "name": "Proof of Narnian #3236",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3236?s=4f84d7eee8eba5a7f071b02affa4c523",
    "price": "2.1 ETH"
  },
  {
    "id": "narnian-3235",
    "name": "Proof of Narnian #3235",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3235?s=2028742cb915578cf481818149e3d2ca",
    "price": "1.3 ETH"
  },
  {
    "id": "narnian-3234",
    "name": "Proof of Narnian #3234",
    "image": "https://assets.bueno.art/images/8ed96917-8f03-4d32-aa1f-78de8d7d05ab/default/3234?s=3655548746fa4c0aaf5d26f069bc51da",
    "price": "1.9 ETH"
  }




];